/* LX motion + interactions — ÖVIE. Vanilla, no deps. */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- money ---------- */
  const fmt = window.lxMoneyFormat || '${{amount}}';
  window.lxMoney = function (cents) {
    const n = (Number(cents) || 0) / 100;
    const withDec = n.toFixed(2);
    const noDec = Math.round(n).toString();
    const commaDec = withDec.replace('.', ',');
    return fmt
      .replace('{{amount_no_decimals}}', noDec)
      .replace('{{amount_with_comma_separator}}', commaDec)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDec)
      .replace('{{amount_with_apostrophe_separator}}', withDec)
      .replace('{{amount}}', withDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /* ---------- toast ---------- */
  let toastEl, toastT;
  window.lxToast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lx-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2800);
  };

  /* ---------- reveal ---------- */
  function initReveal(root) {
    const els = $$('.lx-reveal, .lx-stagger, .lx-lines, .lx-img-reveal', root);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- counters ---------- */
  function initCounters(root) {
    const els = $$('[data-lx-count]', root);
    if (!els.length) return;
    const run = (el) => {
      const target = parseFloat(el.dataset.lxCount); const dec = (el.dataset.lxCount.split('.')[1] || '').length;
      const suffix = el.dataset.lxSuffix || ''; const dur = 1600; const t0 = performance.now();
      el.textContent = (0).toFixed(dec) + suffix;
      const step = (t) => {
        const p = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * e).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((el) => (el.textContent = el.dataset.lxCount + (el.dataset.lxSuffix || ''))); return; }
    const io = new IntersectionObserver((entries) => { entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }); }, { threshold: 0.5 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    const els = $$('[data-lx-parallax]');
    if (!els.length || reduce) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const speed = parseFloat(el.dataset.lxParallax) || 0.15;
        const center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll); update();
  }

  /* ---------- marquee ---------- */
  function initMarquee(root) {
    $$('.lx-marquee__track', root).forEach((track) => {
      if (track.dataset.ready) return; track.dataset.ready = '1';
      const items = Array.from(track.children); const w = () => track.scrollWidth;
      let guard = 0;
      while (track.scrollWidth < (track.parentElement.clientWidth * 2) + 10 && guard < 8) { items.forEach((i) => track.appendChild(i.cloneNode(true))); guard++; }
      // final duplicate so the -50% loop is seamless
      Array.from(track.children).forEach((i) => track.appendChild(i.cloneNode(true)));
      const speed = parseFloat(track.dataset.speed) || 60; // px per second
      track.style.setProperty('--lx-marquee-duration', (w() / 2 / speed).toFixed(1) + 's');
    });
  }

  /* ---------- header ---------- */
  function initHeader() {
    const header = $('.lx-header'); if (!header) return;
    const setH = () => document.documentElement.style.setProperty('--lx-header-h', header.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
    let last = window.scrollY, ticking = false;
    const update = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 12);
      if (y > 140 && y > last + 4 && !document.body.classList.contains('lx-menu-open')) header.classList.add('is-hidden');
      else if (y < last - 4 || y < 140) header.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    const open = () => { document.body.classList.add('lx-menu-open'); header.classList.remove('is-hidden'); $('.lx-menu') && $('.lx-menu').setAttribute('aria-hidden', 'false'); };
    const close = () => { document.body.classList.remove('lx-menu-open'); $('.lx-menu') && $('.lx-menu').setAttribute('aria-hidden', 'true'); };
    $$('[data-lx-menu-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-lx-menu-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    $$('.lx-menu__sub-btn').forEach((b) => b.addEventListener('click', () => b.parentElement.classList.toggle('is-open')));
  }

  /* ---------- scroller nav ---------- */
  function initScrollers(root) {
    $$('[data-lx-scroller]', root).forEach((wrap) => {
      const track = $('.lx-scroller', wrap); if (!track) return;
      const step = () => { const first = track.children[0]; return first ? first.getBoundingClientRect().width + 16 : 300; };
      $$('[data-lx-prev]', wrap).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
      $$('[data-lx-next]', wrap).forEach((b) => b.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
      const dots = $('.lx-dots', wrap);
      if (dots) {
        const n = track.children.length; dots.innerHTML = '';
        for (let i = 0; i < n; i++) { const d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Go to item ' + (i + 1)); d.addEventListener('click', () => track.children[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })); dots.appendChild(d); }
        const sync = () => { const i = Math.round(track.scrollLeft / step()); $$('button', dots).forEach((d, k) => d.classList.toggle('is-on', k === i)); };
        track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true }); sync();
      }
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions(root) {
    $$('.lx-accordion__btn', root).forEach((btn) => {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', () => {
        const item = btn.closest('.lx-accordion__item'); const group = btn.closest('.lx-accordion');
        const willOpen = !item.classList.contains('is-open');
        if (group && group.dataset.single !== undefined) $$('.lx-accordion__item.is-open', group).forEach((i) => { i.classList.remove('is-open'); $('.lx-accordion__btn', i).setAttribute('aria-expanded', 'false'); });
        item.classList.toggle('is-open', willOpen); btn.setAttribute('aria-expanded', String(willOpen));
      });
    });
  }

  /* ---------- cart ---------- */
  async function addToCart(items) {
    const drawer = $('cart-drawer');
    const body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
    if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(data); if (typeof drawer.open === 'function') setTimeout(() => drawer.open(), 50); }
    else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    document.dispatchEvent(new CustomEvent('lx:cart:added', { detail: data }));
    return data;
  }
  window.lxAddToCart = addToCart;

  function initQuickAdd(root) {
    $$('[data-lx-quick-add]', root).forEach((btn) => {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', async (e) => {
        e.preventDefault(); e.stopPropagation();
        const id = btn.dataset.variantId; if (!id) { window.location.href = btn.dataset.url || '/'; return; }
        btn.classList.add('is-loading'); const label = btn.innerHTML;
        try { await addToCart([{ id: Number(id), quantity: 1 }]); btn.innerHTML = '<span>Added</span>'; setTimeout(() => (btn.innerHTML = label), 1600); }
        catch (err) { window.lxToast(err.message); }
        finally { btn.classList.remove('is-loading'); }
      });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    $$('.lx-product', root).forEach((pd) => {
      if (pd.dataset.ready) return; pd.dataset.ready = '1';
      const form = $('.lx-buy', pd); if (!form) return;
      const variantInput = $('[name="id"]', form); const qtyInput = $('[name="quantity"]', form);
      const atc = $('.lx-atc', pd); const sticky = $('.lx-sticky', pd);
      const priceEls = $$('[data-lx-price]', pd); const cmpEl = $('[data-lx-compare]', pd);
      const stickyPrice = $('[data-lx-sticky-price]', pd);
      const variants = (() => { try { return JSON.parse($('[data-lx-variants]', pd).textContent); } catch (e) { return []; } })();
      const getVariant = () => variants.find((v) => String(v.id) === String(variantInput.value)) || variants[0];

      const renderPrice = () => {
        const v = getVariant(); if (!v) return;
        const opt = $('.lx-qty-opt input:checked', pd); const qty = opt ? Number(opt.value) : 1; const pct = opt ? Number(opt.dataset.discount || 0) : 0;
        const unit = v.price; const total = Math.round(unit * qty * (1 - pct / 100));
        const cmp = (v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price) * qty;
        priceEls.forEach((el) => (el.textContent = window.lxMoney(total)));
        if (cmpEl) { if (cmp > total) { cmpEl.textContent = window.lxMoney(cmp); cmpEl.hidden = false; } else cmpEl.hidden = true; }
        if (stickyPrice) stickyPrice.textContent = window.lxMoney(total);
        const saveEl = $('[data-lx-save]', pd); if (saveEl) { saveEl.textContent = opt && opt.dataset.save ? opt.dataset.save : ''; saveEl.hidden = !(opt && opt.dataset.save); }
        const stickyCmp = $('[data-lx-sticky-compare]', pd); if (stickyCmp) { if (cmp > total) { stickyCmp.textContent = window.lxMoney(cmp); stickyCmp.hidden = false; } else stickyCmp.hidden = true; }
        if (qtyInput) qtyInput.value = qty;
        $$('.lx-qty-opt', pd).forEach((o) => o.classList.toggle('is-on', $('input', o).checked));
        if (atc) { const label = $('.lx-atc__label', atc); if (label) label.textContent = v.available ? (atc.dataset.label || 'Add to bag') : (atc.dataset.soldout || 'Sold out'); atc.disabled = !v.available; }
      };
      $$('.lx-qty-opt input', pd).forEach((i) => i.addEventListener('change', renderPrice));
      $$('[data-lx-option]', pd).forEach((sel) => sel.addEventListener('change', () => {
        const chosen = $$('[data-lx-option]', pd).map((s) => s.value);
        const v = variants.find((x) => x.options.every((o, k) => o === chosen[k]));
        if (v) { variantInput.value = v.id; const img = $('.lx-gallery__main', pd); if (v.featured_media && img) { const slide = $('[data-media-id="' + v.featured_media.id + '"]', img); slide && slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); } }
        renderPrice();
      }));
      renderPrice();

      const submit = async (e) => {
        e.preventDefault(); if (!atc || atc.disabled) return;
        atc.classList.add('is-loading'); sticky && sticky.classList.add('is-loading');
        try { await addToCart([{ id: Number(variantInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }]); }
        catch (err) { window.lxToast(err.message); }
        finally { atc.classList.remove('is-loading'); sticky && sticky.classList.remove('is-loading'); }
      };
      form.addEventListener('submit', submit);
      const stickyBtn = $('.lx-sticky__btn', pd); stickyBtn && stickyBtn.addEventListener('click', submit);

      // gallery
      const main = $('.lx-gallery__main', pd); const thumbs = $$('.lx-gallery__thumb', pd); const dots = $('.lx-gallery__dots', pd);
      if (main) {
        const slides = Array.from(main.children);
        if (dots) { dots.innerHTML = ''; slides.forEach((s, i) => { const d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (i + 1)); d.addEventListener('click', () => s.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })); dots.appendChild(d); }); }
        const sync = () => { const i = Math.round(main.scrollLeft / main.clientWidth); thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); dots && $$('button', dots).forEach((d, k) => d.classList.toggle('is-on', k === i)); };
        main.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true }); sync();
        thumbs.forEach((t, i) => t.addEventListener('click', () => slides[i] && slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })));
        $$('[data-lx-gprev]', pd).forEach((b) => b.addEventListener('click', () => main.scrollBy({ left: -main.clientWidth, behavior: 'smooth' })));
        $$('[data-lx-gnext]', pd).forEach((b) => b.addEventListener('click', () => main.scrollBy({ left: main.clientWidth, behavior: 'smooth' })));
      }
      // sticky bar
      if (sticky && atc && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
        io.observe(atc);
      }
    });
  }

  /* ---------- compare slider ---------- */
  function initCompare(root) {
    $$('.lx-compare', root).forEach((c) => {
      const r = $('input[type=range]', c); if (!r || r.dataset.ready) return; r.dataset.ready = '1';
      const set = () => c.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  }

  /* ---------- video reel ---------- */
  function initVideos(root) {
    const vids = $$('.lx-reel video', root); if (!vids.length) return;
    vids.forEach((v) => { v.muted = true; v.playsInline = true; });
    if (!('IntersectionObserver' in window)) { vids.forEach((v) => v.play().catch(() => {})); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { const v = en.target; if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }), { threshold: 0.4 });
    vids.forEach((v) => io.observe(v));
    $$('.lx-reel__sound', root).forEach((b) => b.addEventListener('click', () => { const v = $('video', b.parentElement); if (!v) return; v.muted = !v.muted; b.classList.toggle('is-on', !v.muted); }));
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    $$('[data-lx-tabs]', root).forEach((t) => {
      const btns = $$('[data-lx-tab]', t); const panels = $$('[data-lx-panel]', t);
      btns.forEach((b) => b.addEventListener('click', () => {
        btns.forEach((x) => x.classList.toggle('is-on', x === b)); panels.forEach((p) => p.classList.toggle('is-on', p.dataset.lxPanel === b.dataset.lxTab));
      }));
    });
  }


  /* ---------- countdown (daily reset, persisted) ---------- */
  function initCountdown(root) {
    $$('[data-lx-countdown]', root).forEach((el) => {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      const hours = Math.max(1, parseFloat(el.dataset.hours) || 10); const key = 'lx-cd-' + (el.dataset.key || 'default');
      const fresh = () => Date.now() + hours * 3600 * 1000;
      let end = 0; try { end = Number(localStorage.getItem(key)) || 0; } catch (e) {}
      if (!end || end < Date.now() || end > Date.now() + hours * 3600 * 1000) { end = fresh(); try { localStorage.setItem(key, String(end)); } catch (e) {} }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let left = end - Date.now();
        if (left <= 0) { end = fresh(); try { localStorage.setItem(key, String(end)); } catch (e) {} left = end - Date.now(); }
        const s = Math.floor(left / 1000); el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- read more (clamped quotes) ---------- */
  function initReadMore(root) {
    $$('[data-lx-more]', root).forEach((btn) => {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-lx-clamp]') || btn.parentElement; const open = card.classList.toggle('is-open');
        btn.textContent = open ? (btn.dataset.less || 'Read less') : (btn.dataset.more || 'Read more');
      });
    });
  }


  /* ---------- hero slideshow ---------- */
  function initHero(root) {
    $$('[data-lx-hero]', root).forEach((hero) => {
      if (hero.dataset.ready) return; hero.dataset.ready = '1';
      const slides = $$('.lx-hero__slide', hero);
      const dots = $$('[data-lx-hero-dot]', hero);
      const toggle = $('[data-lx-hero-toggle]', hero);
      if (slides.length < 2) { if (toggle) toggle.hidden = true; return; }
      const ms = parseInt(hero.dataset.interval, 10) || 6000;
      let i = 0, timer = null, paused = reduce;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, k) => { const on = k === i; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', String(!on)); });
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      const start = () => { stop(); if (!paused) timer = setInterval(() => show(i + 1), ms); };
      if (toggle) {
        toggle.classList.toggle('is-paused', paused);
        toggle.addEventListener('click', () => {
          paused = !paused;
          toggle.classList.toggle('is-paused', paused);
          toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
          if (paused) stop(); else start();
        });
      }
      dots.forEach((d, k) => d.addEventListener('click', () => { show(k); start(); }));
      show(0); start();
    });
  }

  /* ---------- finishing touches ---------- */
  function initProgress() {
    if (reduce) return;
    const bar = document.createElement('div'); bar.className = 'lx-progress'; bar.innerHTML = '<i></i>'; document.body.appendChild(bar);
    const i = bar.firstChild; let t = false;
    const upd = () => { const h = document.documentElement.scrollHeight - window.innerHeight; i.style.setProperty('--p', h > 0 ? Math.min(1, window.scrollY / h).toFixed(3) : 0); t = false; };
    window.addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }
  function initIntro() {
    if (reduce || !document.body.dataset.lxIntro) return;
    try { if (sessionStorage.getItem('lx-intro')) return; sessionStorage.setItem('lx-intro', '1'); } catch (e) { return; }
    const el = document.createElement('div'); el.className = 'lx-intro'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<img src="' + document.body.dataset.lxIntro + '" alt="">'; document.body.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-done')));
    setTimeout(() => el.remove(), 2600);
  }
  function initMagnet(root) {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('.lx-btn, .lx-nav__btn', root).forEach((b) => {
      if (b.dataset.magnet) return; b.dataset.magnet = '1'; b.classList.add('lx-magnet');
      b.addEventListener('mousemove', (e) => { const r = b.getBoundingClientRect(); const x = (e.clientX - r.left - r.width / 2) / r.width; const y = (e.clientY - r.top - r.height / 2) / r.height; b.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 8).toFixed(1) + 'px)'; });
      b.addEventListener('mouseleave', () => { b.style.transform = ''; });
    });
  }
  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('.lx-card__media, .lx-bundle__media, .lx-tile', root).forEach((el) => {
      if (el.dataset.tilt) return; el.dataset.tilt = '1'; el.classList.add('lx-tilt');
      el.addEventListener('mousemove', (e) => { const r = el.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - 0.5; const y = (e.clientY - r.top) / r.height - 0.5; el.classList.add('is-tilting'); el.style.transform = 'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg)'; });
      el.addEventListener('mouseleave', () => { el.classList.remove('is-tilting'); el.style.transform = ''; });
    });
  }
  function initSteps(root) {
    const lists = $$('.lx-steps', root); if (!lists.length || reduce) return;
    let t = false;
    const upd = () => { const vh = window.innerHeight; lists.forEach((l) => { const r = l.getBoundingClientRect(); const p = Math.min(1, Math.max(0, (vh * 0.75 - r.top) / r.height)); l.style.setProperty('--fill', p.toFixed(3)); }); t = false; };
    window.addEventListener('scroll', () => { if (!t) { t = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }
  document.addEventListener('lx:cart:added', () => { const b = $('#cart-icon-bubble .cart-count-bubble'); if (b) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); } });

  function boot(root) {
    initReveal(root); initCounters(root); initMarquee(root); initScrollers(root); initAccordions(root);
    initQuickAdd(root); initProduct(root); initCompare(root); initVideos(root); initTabs(root); initMagnet(root); initTilt(root); initSteps(root); initCountdown(root); initReadMore(root); initHero(root);
  }
  const start = () => { initIntro(); initHeader(); initParallax(); initProgress(); boot(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // theme editor: re-init a section after it is re-rendered
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
